/**
 * Module dependencies.
 */

import { DetailedService, Service } from 'src/types/service';
import { Locale } from 'i18n-routes';
import { axiosInstance, getApiEndpoint } from 'src/core/requests';
import { camelCaseObjectKeys } from 'src/core/utils/objects';
import { getHeadersWithLocale } from 'src/core/utils/requests';
import groupBy from 'lodash/groupBy';

/**
 * `ServicesParams` type.
 */

type ServicesParams = {
  filter: {
    category?: Service['category'];
    sub_category?: Service['subCategory'];
  };
};

/**
 * Export `ServicesBySubcategory` type.
 */

export type ServicesBySubcategory = Record<Service['subCategory'], Service[]>;

/**
 * Export `getService` request.
 */

export async function getService(
  slug: string,
  locale: Locale
): Promise<DetailedService> {
  const response = await axiosInstance.get(
    getApiEndpoint('service', { slug }),
    getHeadersWithLocale(locale)
  );

  return camelCaseObjectKeys(response?.data?.data);
}

/**
 * Export `getServices` request.
 */

export async function getServices(
  locale: Locale,
  params?: ServicesParams
): Promise<Service[]> {
  const response = await axiosInstance.get(getApiEndpoint('services'), {
    ...getHeadersWithLocale(locale),
    params
  });

  return response?.data?.data.map(camelCaseObjectKeys);
}

/**
 * Export `getServices` request.
 */

export async function getServicesBySubcategory(
  locale: Locale,
  params?: ServicesParams
) {
  const services = await getServices(locale, params);

  return groupBy(services, 'subCategory') as ServicesBySubcategory;
}
